import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/detection',
    name: 'detection',
    component: () => import('@/views/DetectionView.vue')
  },
  {
    path: '/monitoring',
    name: 'monitoring',
    component: () => import('@/views/MonitoringView.vue')
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/SettingsView.vue')
  },
  {
    path: '/online',
    name: 'online',
    component: () => import('@/views/OnlineView.vue'),
    meta: { hidden: true } // 标记为隐藏，不在导航中显示
  },
  {
    path: '/play',
    name: 'play',
    component: () => import('@/views/PlayView.vue')
  },
  {
    path: '/device-test',
    name: 'device-test',
    component: () => import('@/views/DeviceDetectionTest.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router